import {ApiClient} from '@hconnect/apiclient'
import type {User} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'

const QueryKey = 'machine-sentry-user-search'
const CACHE_TIME_IN_MS = 1000 * 60

type UseMachineSentryUserSearchOptions = Omit<
  UseQueryOptions<User[], AxiosError>,
  'queryKey' | 'queryFn'
>

export const useMachineSentryUserSearch = (
  plantUpmId: string,
  namePattern: string | undefined,
  options?: UseMachineSentryUserSearchOptions
) => {
  return useQuery<User[], AxiosError>({
    queryKey: [QueryKey, namePattern, plantUpmId],
    queryFn: async ({signal}) => {
      if (!plantUpmId || !namePattern) {
        return []
      }

      const path = `${TasksApiPath.MACHINE_SENTRY_ACTIONS}/${plantUpmId}/users`
      const response = await ApiClient.axiosInstance.get<User[]>(path, {
        params: {namePattern},
        signal
      })

      return response.data
    },
    gcTime: CACHE_TIME_IN_MS,
    refetchOnWindowFocus: false,
    ...options
  })
}
